import * as XLSX from 'xlsx'

function sanitizeFileName(value) {
  return String(value || 'report')
    .replace(/[\\/:*?"<>|]/g, '-')
    .replace(/\s+/g, '_')
    .slice(0, 120)
}

export function exportRowsToExcel({ fileName, sheetName, columns, rows }) {
  const safeColumns = Array.isArray(columns) ? columns : []
  const safeRows = Array.isArray(rows) ? rows : []

  const headerRow = safeColumns.map((column) => column.header || '')
  const bodyRows = safeRows.map((row) => (
    safeColumns.map((column) => {
      const value = typeof column.value === 'function' ? column.value(row) : row?.[column.key]
      return value == null ? '' : value
    })
  ))

  const worksheet = XLSX.utils.aoa_to_sheet([headerRow, ...bodyRows])
  worksheet['!cols'] = safeColumns.map((column) => ({
    wch: Math.max(String(column.header || '').length + 2, Number(column.width || 14))
  }))

  // 数字格式列：对数值单元格设置 number format（如金额列 '0.00'）
  safeColumns.forEach((column, colIndex) => {
    if (!column.format) return
    const colLetter = XLSX.utils.encode_col(colIndex)
    for (let rowIndex = 0; rowIndex < bodyRows.length; rowIndex++) {
      const cell = worksheet[`${colLetter}${rowIndex + 2}`]
      if (cell && cell.t === 'n') {
        cell.z = column.format
      }
    }
  })

  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, String(sheetName || 'Sheet1').slice(0, 31))
  XLSX.writeFile(workbook, `${sanitizeFileName(fileName)}.xlsx`)
}

export function exportRowsToCsv({ fileName, columns, rows }) {
  const safeColumns = Array.isArray(columns) ? columns : []
  const safeRows = Array.isArray(rows) ? rows : []

  const headerRow = safeColumns.map((column) => column.header || '')
  const bodyRows = safeRows.map((row) => (
    safeColumns.map((column) => {
      const value = typeof column.value === 'function' ? column.value(row) : row?.[column.key]
      return value == null ? '' : value
    })
  ))

  const worksheet = XLSX.utils.aoa_to_sheet([headerRow, ...bodyRows])
  // BOM 前缀保证 Excel 打开中文不乱码；逗号/引号/换行转义由 sheet_to_csv 处理
  const csvContent = XLSX.utils.sheet_to_csv(worksheet)
  const blob = new Blob([`\uFEFF${csvContent}`], { type: 'text/csv;charset=utf-8;' })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', `${sanitizeFileName(fileName)}.csv`)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}
